import { normalizeInviteEmail } from '@modules/projects/project-members.utils'
import type { User } from '@modules/user/user.interface'

export type WorkspaceMemberIdentity = {
  email?: string | null
  id: string
}

export function getCurrentUserMembershipUserId(currentUser: User | null): string | null {
  if (!currentUser) {
    return null
  }

  const regionalUserId = currentUser.regionalData?.userId?.trim()
  if (regionalUserId) {
    return regionalUserId
  }

  const regionalUid = currentUser.regionalIdentity?.userUid?.trim()
  if (regionalUid) {
    return regionalUid
  }

  const authSubject = currentUser.id?.trim()
  return authSubject || null
}

export function isCurrentWorkspaceMember(member: WorkspaceMemberIdentity, currentUser: User | null): boolean {
  if (!currentUser) {
    return false
  }

  const memberId = member.id.trim()
  if (!memberId) {
    return false
  }

  const regionalUserId = currentUser.regionalData?.userId?.trim()
  if (regionalUserId && memberId === regionalUserId) {
    return true
  }

  const regionalUid = currentUser.regionalIdentity?.userUid?.trim()
  if (regionalUid && memberId === regionalUid) {
    return true
  }

  if (currentUser.id && memberId === currentUser.id) {
    return true
  }

  const memberEmail = normalizeInviteEmail(member.email ?? '')
  if (!memberEmail) {
    return false
  }

  const regionalEmail = currentUser.regionalData?.userEmail?.trim()
  const profileEmail = currentUser.profile?.email?.trim()
  const userEmail = normalizeInviteEmail(regionalEmail || profileEmail || '')

  return userEmail.length > 0 && userEmail === memberEmail
}
